export default __webpack_public_path__ + "static/media/works.1727229a.svg";